import { useTranslation } from "react-i18next";

/**
 * Platform role → i18n label key, so the role renders as a localized label
 * ("Superadmin" / "Super admin") rather than the raw `super_admin` enum in the
 * Account page and the header chip.
 */
export const ROLE_LABEL_KEYS: Record<string, string> = {
  super_admin: "roles.superAdmin",
};

/**
 * Returns a `(role) => localized label` function. Unknown roles fall back to
 * the raw value. Hook form so it tracks the active i18next language.
 */
export function useRoleLabel(): (role: string | null | undefined) => string {
  const { t } = useTranslation();
  return (role) => {
    if (!role) return "";
    const key = ROLE_LABEL_KEYS[role];
    return key ? t(key) : role;
  };
}
